import { render } from "./DamageList.vue?vue&type=template&id=a685a922"
import script from "./DamageList.vue?vue&type=script&lang=js"
export * from "./DamageList.vue?vue&type=script&lang=js"

import "./DamageList.vue?vue&type=style&index=0&id=a685a922&lang=css"
script.render = render

export default script